const numberFormats = {
  en: {
    currency: {
      style: "currency",
      currency: "USD"
    }
  },
  de: {
    currency: {
      style: "currency",
      currency: "EUR",
      currencyDisplay: "symbol"
    }
  }
};

export { numberFormats };
